// 部门管理
export default {
    departmentalInquiry: '部门查询',
    personInChargeInquiry: '负责人查询',
    mobileNumberQuery: '手机号码查询',
    department: '部门',
    numberOfPeople: '人数',
    principal: '负责人',
    contactInformation: '联系方式',
    countryOrRegion: '国家/地区',
    provinceCity: '省/市',
    personnelManagement: '人员管理',
    addDepartment: '添加部门',
    editDepartment: '编辑部门',
    departmentName: '部门名称',
    location: '所在地',
    userAccount: '用户账号',
    role: '角色',
    licenseType: '执照类型',
    departmentDescription: '部门描述',
    pleaseEnterContent: '请输入内容',
    nameQuery: '姓名查询',
    license: '执照',
    totalStaff: '人员总计',
    personsName: '人员姓名',
    telephone: '电话',
    operate: '操作',
    enterDepartmentName: '请输入部门名称',
    PleaseSelectLocation: '请选择所在地',
    enterPerson: '请输入负责人',
    peopleSearch: '人员搜索',
    userExistsTip:"用户已存在，请勿重复添加",
    addFailedTip:"添加失败，用户已在其他部门",
    selectAddper:'请选择需要添加的人员',
    delTip:'注意！部门被删除后，部门人员信息将会保留，部门数据会被删除，请谨慎操作',
    delDep:'删除部门'
}
